// Import polyfills - Thank you IE
import 'react-app-polyfill/stable';
import 'react-app-polyfill/ie11';
import 'core-js';

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Auth0Provider } from '@auth0/auth0-react';

import App from './App';
import * as serviceWorker from './serviceWorker';
import store from './store';
import getFromConfig from 'constants/config';
import { TYPES as ACCOUNT_TYPES } from 'account/modules/account';

import './styles.css';

const AUTH0_CLIENT_ID = getFromConfig('REACT_APP_AUTH0_CLIENT_ID');
const AUTH0_AUDIENCE = getFromConfig('REACT_APP_AUTH0_AUDIENCE');
const AUTH0_DOMAIN = getFromConfig('REACT_APP_AUTH0_DOMAIN');

function getConnectionFromUrl() {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('connection') || undefined;
}

const loginWithRedirect = props => {
  store.dispatch({ type: ACCOUNT_TYPES.SET_FRESH_LOGIN, returnTo: props?.returnTo || window.location.pathname });
};

const Root = ({ store }) => (
  <Auth0Provider
    domain={AUTH0_DOMAIN}
    clientId={AUTH0_CLIENT_ID}
    audience={AUTH0_AUDIENCE}
    connection={getConnectionFromUrl()}
    redirectUri={window.location.origin}
    onRedirectCallback={loginWithRedirect}
  >
    <Provider store={store}>
      <App />
    </Provider>
  </Auth0Provider>
);

ReactDOM.render(<Root store={store} />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
